export default __webpack_public_path__ + "static/media/3.584525c2.svg";